import type { UserLogDto } from "../../types/UserLogDto";
import type { UserLogEntity } from "../../types/UserLogEntity";

export const UserLogDtoToEntity = ({ ...rest }: Readonly<UserLogDto>): UserLogEntity => {
    return { ...rest };
};
